import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Textarea as MatTextArea } from 'react-materialize';

const Content = styled.div`
    display: flex;
    margin: ${props => props.margin ? props.margin : '0 0'};
`;

const TextArea = (props) => {
    return (
        <Content 
            margin={props.margin}>
            <MatTextArea 
                id={props.id} 
                placeholder={props.placeholder}
                maxLength={props.length}
                name={props.name}
                value={props.value}
                onChange={props.onChange} />
        </Content>
    );
}

TextArea.propTypes = {
    id: PropTypes.string,
    placeholder: PropTypes.string,
    length: PropTypes.string, 
    margin: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string, 
    onChange: PropTypes.func 
}

export default TextArea;